export default "__VITE_ASSET__Da6et_Ss__"